import globalAxios from "../../../util/Api";
import {
  GET_USERS_DATA, DELETE_USER, CREATE_USER, EDIT_USER, START_LOADING, USER_ERROR,
  STOP_LOADING,
  GET_ACCESS_RIGHTS,
  GET_CONSULTANT_COST,
} from "./types";
import { GetConsultantsFunction } from "../../ConsultantFunction/consultantAction";
import { GetCountries } from "../../Land/LandActions";
import { GetCategories } from "../../UserCategories/categoriesAction";
import numeral from 'numeral';
import { LogoutAction } from "../../../actions";
import 'numeral/locales/de'
numeral.locale('de');

export const GetUsers = () => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/users`)
      .then(res => {
        const newres = res.data.users.map(obj => {
          obj['name'] = obj['full_name']
          delete obj['full_name']
          return obj
        })
        if (newres) {
          dispatch({ type: GET_USERS_DATA, payload: newres })
          dispatch(GetConsultantsFunction())
          dispatch(GetCountries())
          dispatch(GetCategories())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

export const CreateNewUser = (dataObj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('email', dataObj.mail);
  bodyFormData.append('password', dataObj.password);
  bodyFormData.append('password_confirmation', dataObj.confirmPassword);
  bodyFormData.append('loginname', dataObj.loginName);
  bodyFormData.append('firstname', dataObj.vorName);
  bodyFormData.append('lastname', dataObj.nachName);
  bodyFormData.append('salutation', dataObj.anrede);
  bodyFormData.append('title', dataObj.title);
  bodyFormData.append('active', dataObj.active);
  bodyFormData.append('startdate', dataObj.eintritt);
  bodyFormData.append('enddate', dataObj.austritt);
  bodyFormData.append('category_id', dataObj.categoryId);
  bodyFormData.append('consultant_function_id', dataObj.consultentId);
  bodyFormData.append('country_id', dataObj.countryID === null ? '' : dataObj.countryID);
  bodyFormData.append('street', dataObj.street);
  bodyFormData.append('zipcode', dataObj.zipcode);
  bodyFormData.append('city', dataObj.city);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/auth`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['full_name']
        delete newres['full_name']
        if (newres) {
          dispatch({ type: CREATE_USER, payload: newres })
          dispatch(GetUsers())
          dispatch({ type: GET_CONSULTANT_COST, payload: '' })
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
      })
  }
}

export const EditUser = (dataObj) => {
  let bodyFormData = new FormData();
  const user = JSON.parse(localStorage.getItem('user'))
  bodyFormData.append('email', dataObj.mail);
  bodyFormData.append('password', dataObj.password);
  bodyFormData.append('password_confirmation', dataObj.confirmPassword);
  bodyFormData.append('loginname', dataObj.loginName);
  bodyFormData.append('firstname', dataObj.vorName);
  bodyFormData.append('lastname', dataObj.nachName);
  bodyFormData.append('salutation', dataObj.anrede);
  bodyFormData.append('title', dataObj.title);
  bodyFormData.append('active', dataObj.active);
  bodyFormData.append('startdate', dataObj.eintritt);
  bodyFormData.append('enddate', dataObj.austritt);
  bodyFormData.append('category_id', dataObj.categoryId);
  bodyFormData.append('consultant_function_id', dataObj.consultentId === null ? "" : dataObj.consultentId);
  bodyFormData.append('country_id', dataObj.countryID === null ? '' : dataObj.countryID);
  bodyFormData.append('street', dataObj.street);
  bodyFormData.append('zipcode', dataObj.zipcode);
  bodyFormData.append('city', dataObj.city);
  bodyFormData.append('id', dataObj.userId);
  bodyFormData.append('change_right', dataObj.changeCategory);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/auth`, bodyFormData)
      .then(res => {
        if (res.data.data.id === user.id) {
          user['loginname'] = res.data.data.loginname
          localStorage.setItem('user', JSON.stringify(user));
        }
        const newres = res.data.data
        newres['name'] = newres['full_name']
        delete newres['full_name']
        if (newres) {
          dispatch({ type: EDIT_USER, payload: newres })
          dispatch(GetUsers())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
      })
  }
}

export const DeleteUser = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/auth?id=${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_USER })
          dispatch(GetUsers())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
      })
  }
}
export const GetUserAccessRight = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/access_rights?id=${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_ACCESS_RIGHTS, payload: res.data.access_rights })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: USER_ERROR, payload: err.message })
      })
  }
}
export const EditUserAccessRight = (userID, dataObj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('id', userID);
  bodyFormData.append('user[access_right_attributes][system_settings]', dataObj.systemSettings);
  bodyFormData.append('user[access_right_attributes][user_categories]', dataObj.userCategories);
  bodyFormData.append('user[access_right_attributes][consultant_functions]', dataObj.consultantFunctions);
  bodyFormData.append('user[access_right_attributes][consultant_categories]', dataObj.consultantCategories);
  bodyFormData.append('user[access_right_attributes][users]', dataObj.users);
  bodyFormData.append('user[access_right_attributes][classifications]', dataObj.classifications);
  bodyFormData.append('user[access_right_attributes][branches]', dataObj.branches);
  bodyFormData.append('user[access_right_attributes][themes]', dataObj.theme);
  bodyFormData.append('user[access_right_attributes][countries]', dataObj.countries);
  bodyFormData.append('user[access_right_attributes][public_holidays]', dataObj.publicHolidays);
  bodyFormData.append('user[access_right_attributes][customers]', dataObj.customers);
  bodyFormData.append('user[access_right_attributes][project_planning_all_over]', dataObj.project_planning_all_over);
  bodyFormData.append('user[access_right_attributes][projects_basedata_for_own]', dataObj.projectsBaseDataOwn);
  bodyFormData.append('user[access_right_attributes][projects_setting_for_own]', dataObj.projectsSettingOwn);
  bodyFormData.append('user[access_right_attributes][projects_fee_for_own]', dataObj.projectsFeeOwn);
  bodyFormData.append('user[access_right_attributes][projects_capacity_for_own]', dataObj.projectsCapacityOwn);
  bodyFormData.append('user[access_right_attributes][projects_consultants_for_own]', dataObj.projectsConsultantsOwn);
  bodyFormData.append('user[access_right_attributes][projects_invoices_for_own]', dataObj.projectsInvoicesOwn);
  bodyFormData.append('user[access_right_attributes][projects_basedata_for_other]', dataObj.projectsBasedataForOther);
  bodyFormData.append('user[access_right_attributes][projects_setting_for_other]', dataObj.projectsSettingOther);
  bodyFormData.append('user[access_right_attributes][projects_fee_for_other]', dataObj.projectsFeeOther);
  bodyFormData.append('user[access_right_attributes][projects_capacity_for_other]', dataObj.projectsCapacityOther);
  bodyFormData.append('user[access_right_attributes][projects_consultants_for_other]', dataObj.projectsConsultantsOther);
  bodyFormData.append('user[access_right_attributes][projects_invoices_for_other]', dataObj.projectsInvoicesOther);
  bodyFormData.append('user[access_right_attributes][projects_activity_for_own]', dataObj.projectActivityOwn);
  bodyFormData.append('user[access_right_attributes][projects_activity_for_other]', dataObj.projectActivityOther);
  bodyFormData.append('user[access_right_attributes][projects_planning_for_own]', dataObj.projectPlanningForOwn);
  bodyFormData.append('user[access_right_attributes][projects_planning_for_other]', dataObj.projectPlanningForOther);
  bodyFormData.append('user[access_right_attributes][leads]', dataObj.leads);
  bodyFormData.append('user[access_right_attributes][time_reg_for_own]', dataObj.timeRegistrationOwn);
  bodyFormData.append('user[access_right_attributes][time_reg_other_consultants_other]', dataObj.timeRegistrationOther);
  bodyFormData.append('user[access_right_attributes][months_plan]', dataObj.monthsPlan);
  bodyFormData.append('user[access_right_attributes][consultant_plan]', dataObj.consultantPlan);
  bodyFormData.append('user[access_right_attributes][consultant_plan_for_own]', dataObj.consultantPlanOwn);
  bodyFormData.append('user[access_right_attributes][year_overview_customers]', dataObj.yearOverviewCustomers);
  bodyFormData.append('user[access_right_attributes][year_overview_projects]', dataObj.yearOverviewProjects);
  bodyFormData.append('user[access_right_attributes][year_overview_consultants]', dataObj.yearOverviewConsultants);
  bodyFormData.append('user[access_right_attributes][year_overview_students]', dataObj.yearOverviewStudents);
  bodyFormData.append('user[access_right_attributes][year_overview_themes]', dataObj.yearOverviewThemes);
  bodyFormData.append('user[access_right_attributes][year_overview_leads]', dataObj.yearOverviewLeads);
  bodyFormData.append('user[access_right_attributes][year_overview_vacation]', dataObj.vacationOverview);
  bodyFormData.append('user[access_right_attributes][year_overview_resource_planning]', dataObj.ressourcePlanning);
  bodyFormData.append('user[access_right_attributes][archive]', dataObj.archive);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/users`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: GET_ACCESS_RIGHTS, payload: res.data.access_rights })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: USER_ERROR, payload: err.message })
      })
  }
}

export const GetConsultantCost = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/consultant_costs?user_id=${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_CONSULTANT_COST, payload: res.data.consultant_costs })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })

        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: USER_ERROR, payload: err.message })
      })
  }
}
export const AddConsultantCost = (id, dataObj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('consultant_cost[user_id]', id);
  bodyFormData.append('consultant_cost[daily_rate]', numeral(dataObj.costField).value());
  bodyFormData.append('consultant_cost[month]', "01." + dataObj.yearMothField);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/consultant_costs`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch(GetConsultantCost(id))

        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: USER_ERROR, payload: err.message })
      })
  }
}
export const EditConsultantCost = (id, dataObj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('consultant_cost[user_id]', id);
  bodyFormData.append('consultant_cost[daily_rate]', numeral(dataObj.costField).value());
  bodyFormData.append('consultant_cost[month]', "01." + dataObj.yearMothField);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/consultant_costs/${dataObj.costID}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch(GetConsultantCost(id))
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: USER_ERROR, payload: err.message })
      })
  }
}
export const DeletetConsultantCost = (userId, costId) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/consultant_costs/${costId}`)
      .then(res => {
        if (res) {
          dispatch(GetConsultantCost(userId))
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: USER_ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: USER_ERROR, payload: err.message })
      })
  }
}

export const StopLoading = () => {
  return (dispatch) => {
    dispatch({ type: STOP_LOADING })
  }
}
